import React, { useState } from 'react'
import { Typography, Button } from 'antd'
import { useIntl } from 'react-intl'
import { ArrowRightOutlined } from '@ant-design/icons'

import HeartShield from 'assets/images/heart-shield.svg?react'
import { SendWaModal } from 'components/UI'
import styles from './whatsapp-personal-number-card.module.scss'

const { Text } = Typography

const WhatsAppPersonalNumberCard = ({
  data,
  getWaTemplate,
  goToWaTamplate,
  transTypeId,
  waTemplateKey,
  onClose,
}) => {
  const [openWhatsappModal, setOpenWhatsappModal] = useState(false)

  const { formatMessage } = useIntl()

  return (
    <>
      <div className={styles.personalNumberCard}>
        <div className={styles.personalNumberContainer}>
          <div className={styles.iconWrapper}>
            <HeartShield />
          </div>
          <div>
            <div className={styles.personalNumberText}>
              <Text className={styles.personalNumberTitle}>
                {formatMessage({ id: 'financeInvoices.send_via_personal_number' })}
              </Text>
              <Text className={styles.personalNumberDesc}>
                {formatMessage({ id: 'financeInvoices.send_via_personal_number_desc' })}
              </Text>
            </div>
            <Button
              className={styles.personalNumberFooter}
              onClick={() => setOpenWhatsappModal(true)}
              type="text"
            >
              <Text className={styles.whatsappLink}>
                {formatMessage({ id: 'financeInvoices.send_whatsapp' })}
              </Text>
              <ArrowRightOutlined className={styles.arrowIcon} />
            </Button>
          </div>
        </div>
      </div>
      {openWhatsappModal && (
        <SendWaModal
          sendTitle={formatMessage({ id: 'button.send_wa' })}
          getWaTemplate={getWaTemplate}
          show
          data={data}
          onCloseWaModal={onClose}
          goToWaTamplate={goToWaTamplate}
          hideOfficial
          id={data?.id}
          transTypeId={transTypeId}
          waTemplateKey={waTemplateKey}
        />
      )}
    </>
  )
}

export default WhatsAppPersonalNumberCard
